import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportCarburetion3Types } from "redux/reducers/Reports/reportCarburetion3/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_CARBURETION3_FILTERS } = reportCarburetion3Types;

export const getReportCarburetion3Action = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingCarburetion3'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/carburations-3?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Carburación_3_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingCarburetion3'));
    }
  };
};

export const setReportCarburetion3Filters = (key = "", value) => ({
  type: SET_CARBURETION3_FILTERS,
  payload: { key, value }
});
